import React from "react";

interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Accessible name and tooltip — say what turning it on does, e.g. "Pause this schedule" */
  label: string;
  disabled?: boolean;
  className?: string;
}

// The design system's on/off toggle (the one SharedLinksManager draws inline), lifted so new rows share a single switch
export const Switch: React.FC<SwitchProps> = ({ checked, onChange, label, disabled = false, className = "" }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    title={label}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${
      checked ? "bg-eai-cta-primary" : "bg-eai-border-hover"
    } ${className}`}
  >
    <span
      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
        checked ? "translate-x-[18px]" : "translate-x-0.5"
      }`}
    />
  </button>
);

export default Switch;
